export enum ChatComponentType {
  conversations = 'conversations',
  rcs = 'rcs',
  tf911 = 'tf911',
}

export type KeyOfChatComponentType = keyof typeof ChatComponentType;

interface ChatInterface {
  isActive: boolean;
  lastUpdated: number;
}

export type ChatEntry = [KeyOfChatComponentType, ChatInterface];

export type ChatComponents = Record<
  KeyOfChatComponentType,
  ChatInterface | null
>;
